import { Button, Dropdown, Menu, Pagination, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { FormattedMessage, useIntl } from 'react-intl';
import CoferencePopup from '../../components/ConferencePopup/CoferencePopup';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';
import FiltersForm from '../../components/FiltersForm/FiltersForm';
import Icon from '../../components/Icon/Icon';
import Popup from '../../components/Popup/Popup';
import Spinner from '../../components/Spinner/Spinner';
import { Conference, TabStatus } from './BackofficeConferences.model';
import styles from './BackofficeConferences.module.scss';
import { useBackofficeConferences, pageSize } from './useBackofficeConferences';
import moment from "moment";

const BackofficeConferences = () => {
	const {
		deleteConference,
		filterDefaultValues,
		filterFields,
		getConferences,
		onChangePagination,
		onResetFilters,
		onSubmitFilters,
		setSelectedConference,
		state: {
			conferences,
			pagination,
			selectedConference,
			showAddConferecePopup,
			showDeleteConferecePopup,
			showMobileFilters,
			tabStatus
		},
		toggleAddConferencePopup,
		toggleDeleteConferencePopup,
		toggleMobileFilters,
	} = useBackofficeConferences();

	const intl = useIntl();

	const columns: ColumnsType<Conference> = [
		{
			dataIndex: 'name',
			title: intl.formatMessage({ id: 'table.column.name' }),
		},
		{
			dataIndex: 'date',
			render: (date: string) =>
				moment(date).format("DD MMM YYYY"),
			title: intl.formatMessage({ id: 'table.column.date' }),
		},
		{
			render: (record: Conference) => (
				<div className={styles.tableActions}>
					{record.isFuture && <div
						className={styles.edit}
						onClick={() => {
							setSelectedConference(record);
							toggleAddConferencePopup();
						}}
					>
						<span>
							<FormattedMessage id="buttons.edit" />
						</span>
						<Icon name="pen" color="light" type="solid" />
					</div>}
					<Dropdown
						overlay={
							<Menu>
								<Menu.Item>
								<Button type="text" onClick={() => { setSelectedConference(record); toggleDeleteConferencePopup();}}>
									<FormattedMessage id="buttons.delete" />
								</Button>
								</Menu.Item>
							</Menu>
						}
					>
						<Button type="text"><Icon name="ellipsis-h" color="light" /></Button>
					</Dropdown>
				</div>
			),
		},
	];

	const renderDeletePopup = () => {
		return <Popup onClose={() => { toggleDeleteConferencePopup(); setSelectedConference(undefined)}} title={{action: '', target: ''}}>
			<div className={styles.popupContent}>
				<Icon name="trash" color="accent" width="100px"  height="100px" />
				<h1><FormattedMessage id="popupTitles.deleteConfirmation" /></h1>
				<p><FormattedMessage id="conferences.deleteConfirmation" /></p>
				<div className={styles.popupActions}>
					<Button size="large" type="primary" onClick={() => { deleteConference(); toggleDeleteConferencePopup() }}>
						<FormattedMessage id="buttons.delete" />
					</Button>
					<Button size="large" type="default" onClick={() => { toggleDeleteConferencePopup(); setSelectedConference(undefined); }} >
						<FormattedMessage id="buttons.cancel" />
					</Button>
				</div>
			</div>
		</Popup>
	}

	return (
		<div className={styles.pageContainer}>
			<div className={`${styles.pageSider} ${styles.topBorder}`}>
				<FiltersForm
        fields={filterFields}
        defaultValues={filterDefaultValues}
        onResetFilters={onResetFilters}
        onSubmit={(filters) => onSubmitFilters(filters)} />
			</div>
			<div className={styles.pageContent}>
				<div className={styles.mainActions}>
					<h1>
						<FormattedMessage
							id="navigation.conferences"
							values={{ b: (value: any) => <b>{value}</b> }}
						/>
					</h1>
					<Button
						type="primary"
						size="large"
						onClick={toggleAddConferencePopup}
					>
						<FormattedMessage id="buttons.addConference" />
					</Button>
				</div>
				<div className={styles.mobileTopper}>
					<Button
						type="text"
						onClick={toggleMobileFilters}
						icon={<Icon color="black" name="sliders-h" />}
					/>
				</div>
				<div className={styles.tabContent}>
					<Spinner spinning={tabStatus === TabStatus.Loading} />
					<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getConferences} showReport={false}/>
					<Table
						columns={columns}
						dataSource={conferences}
						pagination={false}
						rowKey={(record) => record.id}
					/>

					<div className={styles.paginationWrapper}>
						<Pagination
							className={styles.pagination}
							current={pagination.page}
							pageSize={pageSize}
							total={pagination.total}
							onChange={onChangePagination}
						/>
					</div>
				</div>
				{showAddConferecePopup && (
					<CoferencePopup
						conference={selectedConference}
						onClose={toggleAddConferencePopup}
						onSubmit={() => {
							getConferences();
							setSelectedConference(undefined);
						}}
					/>
				)}
				{
					showDeleteConferecePopup && renderDeletePopup()
				}
			</div>

			 {/* Mobile filters */}
			<div className={`${styles.mobileFiltersBackdrop} ${showMobileFilters ? styles.open : ''}`}></div>
			<div className={`${styles.mobileFilters} ${showMobileFilters ? styles.open : ''}`}>
				<div className={styles.actions}>
					<Button onClick={toggleMobileFilters} type="link" style={{paddingRight: 0}}>
						<Icon
							color="text"
							height="16px"
							name="times"
							width="16px"
						/>
					</Button>
				</div>
				<FiltersForm
					fields={filterFields}
					defaultValues={filterDefaultValues}
					onResetFilters={() => onResetFilters(toggleMobileFilters)}
					onSubmit={(filters) => onSubmitFilters(filters, toggleMobileFilters)} />
			</div>
		</div>
	);
};
export default BackofficeConferences;
